/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useRef } from 'react';
import {
	Dropdown,
	Option,
	makeStyles,
	tokens,
	Card,
} from '@fluentui/react-components';
import { useAutomationRuleActivity } from './activity-provider';
import { useSearchParams } from 'react-router-dom';

const stateOptions = [
	{ label: 'Success', value: 'success' },
	{ label: 'Error', value: 'Error' }
];

const lastTimeOptions = [
	{ label: 'Anytime', value: 'anytime' },
	{ label: 'Last 60 minutes.', value: '60min' },
	{ label: 'Last 4 hours', value: '4h' },
	{ label: 'Last 8 hours', value: '8h' },
	{ label: 'Last 12 hours', value: '12h' },
	{ label: 'Last 24 hours', value: '24h' },
	{ label: 'Last 2 days', value: '2d' },
	{ label: 'Last 3 days', value: '3d' },
	{ label: 'Last 7 days', value: '7d' },
];

let debounceFilter: any = null;

export default function ActivityFilterControl() {
	const [searchParams] = useSearchParams();
	const classes = useStyles();
	const {list, getListByFilter, filter, loadingList} = useAutomationRuleActivity();

	const disableInputs = useMemo(() => {
		const hasFilter = [
			loadingList
		].some(isTrue => isTrue);

		return (!list.length && hasFilter);
	}, [
		list,
		loadingList
	]);

	const init = useRef(true);
	useEffect(() => {
		if (init.current) {
			init.current = false;
		}
	}, []);

	return (
		<Card className={classes.card}>
			<div className={classes.filterRoot}>
				<div className={classes.filterDropdownWrapper}>
					<Dropdown
						disabled={disableInputs}
						className={classes.dropdown}
						appearance="underline"
						placeholder="Status"
						positioning="below-end"
						value={stateOptions.find(item => item.value === filter.state)?.label || ''}
						onOptionSelect={(_, data) => {
							filter.setState(data.optionValue as string);
							clearTimeout(debounceFilter);
							debounceFilter = setTimeout(() => {
								const automationRuleId = searchParams.get('id');
								getListByFilter({
									oldActivityList: [],
									automationRuleId: automationRuleId,
									lastActivityId: null,
									lastTimeFilter: lastTimeOptions.find(item => item.value === filter.time)?.value || '',
									status: data.optionValue
								});
							}, 750);
						}}
					>
						{stateOptions.map((option) => (
							<Option key={option.value} value={option.value}>
								{option.label}
							</Option>
						))}
					</Dropdown>
					<Dropdown
						disabled={disableInputs}
						className={classes.dropdown}
						appearance="underline"
						placeholder='Timeframe'
						positioning="below-end"
						value={lastTimeOptions.find(item => item.value === filter.time)?.label || ''}
						onOptionSelect={(_, data) => {
							filter.setTime(data.optionValue as string);
							clearTimeout(debounceFilter);
							debounceFilter = setTimeout(() => {
								console.log(data.optionValue);
								const automationRuleId = searchParams.get('id');
								getListByFilter({
									oldActivityList: [],
									automationRuleId: automationRuleId,
									lastActivityId: null,
									lastTimeFilter: data.optionValue as string,
								});
							}, 750);
						}}
					>
						{lastTimeOptions.map(item => (
							<Option key={item.value} value={item.value}>
								{item.label}
							</Option>
						))}
					</Dropdown>
				</div>
			</div>
		</Card>
	);
}

const useStyles = makeStyles({
	card: {
		marginBottom: '8px'
	},
	root: {
		boxSizing: 'border-box',
	},
	input: {
		width: '100%',
		borderBottom: 'none',
		'::after': {
			borderBottom: 'none'
		},
		'> input': {
			paddingLeft: '8px',
		},
		':has(input:focus)': {
			borderRadius: tokens.borderRadiusMedium,
			boxShadow: '0 0 0 3px rgba(0, 120, 212, .23), 0 0 0 1px rgba(0, 120, 212, 1)',
		},
	},
	filterRoot: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '16px'
	},
	filterInput: {
		width: '100%'
	},
	dropdown: {
		minWidth: '120px',
		borderBottom: 'none',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		'::after': {
			borderBottom: 'none'
		},
		':hover': {
			background: tokens.colorNeutralShadowAmbientLighter
		},
	},
	filterDropdownWrapper: {
		width: '100%',
		display: 'flex',
		gap: '16px',
		justifyContent: 'flex-end'
	},
});
